import React from 'react';
import {ThreeDots} from 'react-loader-spinner';
import {Wrapper} from './styled';

type LoaderProps = {
  height?: number;
  width?: number;
  color?: string;
  label?: string;
  strokeWidth?: string;
};

const defaultProps: LoaderProps = {
  height: 30,
  width: 30,
  color: '#EEEEEE',
  label: '',
};

function Loader({height, width, color, label, ...props}: LoaderProps) {
  if (label) {
    return (
      <Wrapper>
        <ThreeDots color={color} height={height} width={width} {...props} />
        <div>{label}</div>
      </Wrapper>
    );
  }

  return <ThreeDots color={color} height={height} width={width} {...props} />;
}

Loader.defaultProps = defaultProps;
export {Loader};
